/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=499561f4&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=499561f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499561f4",
  null
  
)

export default component.exports